import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-list',
  templateUrl: './skeleton-list.component.html',
  styleUrls: ['./skeleton-list.component.scss']
})
export class SkeletonListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
